import type { ActivatedRouteSnapshot } from '@angular/router';

/**
 * Returns a normalized URL from the root ActivatedRouteSnapshot
 * @param rootSnapshot The root snapshot
 */
export function getNormalizedRoute(rootSnapshot: ActivatedRouteSnapshot): string {
	if (!rootSnapshot.firstChild) {
		return '';
	}

	return [...activatedrouteSnapshotGenerator(rootSnapshot)]
		.filter(({ routeConfig }) => routeConfig?.path)
		.map(({ routeConfig }) => routeConfig?.path)
		.join('/');
}

export function* activatedrouteSnapshotGenerator(route: ActivatedRouteSnapshot): Generator<ActivatedRouteSnapshot> {
	if (route.firstChild) {
		yield route.firstChild;

		for (const child of activatedrouteSnapshotGenerator(route.firstChild)) {
			yield child;
		}
	}
}
